<template>
    <div>
        <div :class="['page reset',{ off: !pageOn }]">
            <VHeader type="back" @back="back" />
            <div class="page-content">
                <label>
                    <p>Username</p>
                    <input id="username" v-model="un" />
                </label>
                <div class="choose-box">
                    <label>
                        <p>Email</p>
                        <input id="email" v-model="email" />
                    </label>
                    <h2 class="reset">OR</h2>
                    <label>
                        <p>Mobile</p>
                        <input id="phone-mobile" v-model="mobile" />
                    </label>
                </div>

                <label>
                    <p>Password</p>
                    <input id="password" type="password" v-model="pw" />
                </label>
                <label>
                    <p>Confirm PW</p>
                    <input type="password" v-model="confirmpw" />
                </label>
                <p class="btn lg" @click="auth">RESET PASSWORD</p>
            </div>
        </div>
        <transition name="ontop">
            <div v-if="pendingMessage">
                <Pending :state="verifyState" :message="pendingMessage" @exit="exitPending" />
            </div>
        </transition>
    </div>
</template>

<script>

import VHeader from '@/components/VHeader.vue'
import { mapMutations } from 'vuex'
import { pageOn } from '@/utils/pageOn.js'
import Alert from '@/utils/Alert.js'
import WebSoc from '@/utils/WebSoc.js'
import MD5 from '@/utils/MD5.js'
import Pending from '@/components/Pending.vue'

export default {
    components: {
        VHeader,
        Pending
    },
    name: 'reset',
    mixins: [ pageOn ],
    computed: {
        id () { return this.$store.state.id }
    },
    data () {
        return {
            un: '',
            pw: '',
            email: '',
            mobile: '',
            confirmpw: '',
            MDCode: '',
            verifyState: false,
            pendingMessage: ''
        }
    },
    mounted () {
        console.log('this.id',this.id);
        WebSoc.SEND({ t: 'getResetMD5Code' },resp => {
            console.log('Reset mounted resp',resp);
            this.MDCode = resp.code
        })
    },
    methods: {
        back () {
            this.pageOn = false;
        },
        auth () {
            var { un, pw, email, mobile, confirmpw, MDCode } = this;
            var error = message => Alert.message(message);
            if ( !un ) return error('Must have a username')
            if ( !pw || !confirmpw ) return error('Invalid Passwords')
            if ( pw != confirmpw ) return error('Passwords do not match')
            if ( !email && !mobile ) return error('Must have email or mobile');
            console.log({ un, pw, email, mobile, confirmpw, MDCode });
            WebSoc.SEND({ t: 'newPassword', data: { un, email, mobile, pw: MD5.code(pw), url: 'loyalty-vip.com' }},resp => {
                console.log('resp',resp);
                if ( resp.error ) return Alert.message(resp.error);
                if ( resp.text )  return this.pendingMessage = 'A Verification Text has been sent to<br>'+resp.text;
                if ( resp.email ) return this.pendingMessage = 'A Verification eMail has been sent to<br>'+resp.email;
                if ( resp.verify ) { this.verifyState = true; }
            })
        },
        exitPending () {
            this.pendingMessage = '';
            if ( this.verifyState == true ) {
                this.$emit('success');
                this.pageOn = false;
            }
        }
    }
}
</script>

<style lang="scss">
.page.reset {
    .page-content {
        .choose-box {
            width: 80%;
            border: 1px solid white;
            margin: 10px 0px 10px 10%;
            padding-bottom: 10px;
            input { font-size: 14px; }
        }
        h2 { text-align: center; margin-top: 10px; margin-bottom: -15px; } 
        > * { float: left; width: 100%; }
        > p.btn { width: calc(100% - 40px); margin-top: 20px; }
        > label:nth-child(1) { margin-top: 20px; }
        input { font-size: 30px; }
    }
}
</style>